import { createApi } from '@reduxjs/toolkit/query/react'

import { AccidentManagementContactDetails } from './types'
import { baseApi } from './utils'

export const accidentManagementApi = createApi({
	reducerPath: 'accidentManagement',
	...baseApi('/accident-management'),
	endpoints: builder => ({
		getContactDetails: builder.query<AccidentManagementContactDetails, void>({
			query: () => '/contact-details/view.php',
		}),

		getEditContactDetails: builder.query({
			query: () => '/accident-management/contact-details/edit.php',
		}),
		getFnolView: builder.query({
			query: (formId: string) => `/view/?formId=${formId}`,
		}),
	}),
})

export const { useGetContactDetailsQuery, useGetEditContactDetailsQuery, useGetFnolViewQuery } = accidentManagementApi
